import React, { useContext, useEffect, useRef } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { config } from "config";
import { downloadRestoreISOStart } from "store/actions";
import { localDownload } from "utils";
import { LayoutContext } from "App/common/hoc/Layout";

function DownloadISO(props) {
  const { lMethods, lState } = useContext(LayoutContext);
  const lStateRef = useRef();

  //Handling enter key to download iso
  useEffect(() => {
    lStateRef.current = lState;
    const handleKeyDown = e => {
      if (
        e.key === "Enter" &&
        lStateRef.current.popup.alertName === "downloadRestoreISO" &&
        lStateRef.current.popup.show
      ) {
        props.downloadRestoreISOStart(lState?.popup?.params?.origin);
        lMethods.closePopup();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    // Cleanup: Remove the event listener when the component unmounts
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [lState]);

  //Generate url based on whether ibackup or mirror
  function generateFinalUrl(appInstance) {
    let finalURL = "";
    if (appInstance === "idrive") {
      finalURL =
        "https://api.idrivemirror.com/api/v1/static/downloadBuilder/IDriveMirrorISO.iso";
    } else if (appInstance === "ibackup") {
      finalURL =
        config.API_URL +
        (appInstance === "ibackup" ? "/ibackup" : "") +
        "/static/recoveryBuilderISO";
    } else {
      finalURL =
        "https://api.idrivemirror.com/api/v1/static/downloadBuilder/IDriveMirrorISO_mirror.iso";
    }

    localDownload(finalURL);
  }
  return (
    <React.Fragment>
      <div className="srw_body">
        <p className="iso_title">
          Restore the computer to its earlier state including the OS and content
          structure as the original computer. You can also recover individual
          disks to the same or a new computer using a bootable ISO media.
        </p>
        <p className="ul_title">
          Download the ISO builder and do any of the following:
        </p>

        <div className="iso_media_list">
          <ol strat={1} className="iso_ol">
            <li>Install it and create a bootable ISO file for future use.</li>
            <li>Burn it directly to a USB drive for immediate use.</li>
          </ol>
          <p class="download_note">
            <strong>Note: </strong> The C: drive must be backed up to perform a
            full system image restore
          </p>
        </div>
        <div className="media_download">
          <div
            className="media_download_btn"
            onClick={() => {
              props.downloadRestoreISOStart(lState?.popup?.params?.origin);
              lMethods.closePopup();
            }}
          >
            Download Restore ISO Builder
          </div>
        </div>
      </div>
      <p class="download_note_btn">
        To download a generalized{" "}
        {config.APP_INSTANCE === "ibackup"
          ? "IBackup Mirror ISO "
          : "IDrive Mirror ISO "}
        <a
          class="download_lnk"
          style={{ paddingLeft: "4px" }}
          onClick={() => generateFinalUrl(lState?.popup?.params?.origin)}
        >
          click here
        </a>
      </p>
    </React.Fragment>
  );
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ downloadRestoreISOStart }, dispatch);
}

export default connect(null, mapDispatchToProps)(DownloadISO);
